import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import './components.css';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  width?: number;
  footer?: ReactNode;
}

export function Modal({ open, onClose, title, children, width = 560, footer }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onEsc = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="iris-modal-overlay" onClick={onClose}>
      <div
        className="iris-modal"
        style={{ width }}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <header className="iris-modal-header">
            <h2 className="iris-modal-title">{title}</h2>
            <button className="iris-modal-close" onClick={onClose} aria-label="Close">
              <X size={16} strokeWidth={1.5} />
            </button>
          </header>
        )}
        <div className="iris-modal-body">{children}</div>
        {footer && <footer className="iris-modal-footer">{footer}</footer>}
      </div>
    </div>
  );
}
